import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  az: {
    // Navigation
    nav_home: 'Ana Səhifə',
    nav_about: 'Haqqımızda',
    nav_cottages: 'Kotteclər',
    nav_amenities: 'İmkanlar',
    nav_gallery: 'Qalereya',
    nav_contact: 'Əlaqə',
    nav_admin: 'Admin',
    
    // Hero
    hero_title: 'Dağların Qoynunda Huzur',
    hero_subtitle: 'Quba Qəçrəş yolunda, çay kənarında, təbiətin qucağında unutulmaz bir istirahət təcrübəsi',
    hero_cta: 'Kəşf Et',
    
    // About
    about_overline: 'Haqqımızda',
    about_title: 'Təbiətin Qəlbində',
    about_text: 'Oriva Quba, Azərbaycanın ən gözəl guşələrindən birində - Quba rayonunun Qəçrəş yolunda yerləşir. Məkanımız həm dağ mənzərəsi, həm də çay kənarında birbaşa çıxış imkanı təqdim edir. Ailənizlə birlikdə və ya dostlarınızla rahatlıqla vaxt keçirə biləcəyiniz müasir kotteclərimiz sizi gözləyir.',
    
    // Cottages
    cottages_overline: 'Kotteclər',
    cottages_title: 'Premium İstirahət',
    cottages_capacity: 'Nəfərlik',
    cottages_view_details: 'Ətraflı',
    
    // Amenities
    amenities_overline: 'İmkanlar',
    amenities_title: 'Sizin Üçün',
    amenity_river: 'Çaya Birbaşa Çıxış',
    amenity_river_desc: 'Kotteclərimiz çayın birbaşa kənarında yerləşir. Axşamları çay səsini dinləyərək rahatlaya bilərsiniz.',
    amenity_mountain: 'Dağ Mənzərəsi',
    amenity_mountain_desc: 'Hər kottecdən Quba dağlarının möhtəşəm mənzərəsini seyr edə bilərsiniz.',
    amenity_playground: 'Uşaq Oyun Parkı',
    amenity_playground_desc: 'Balacalar üçün təhlükəsiz və əyləncəli oyun sahəsi mövcuddur.',
    amenity_restaurant: 'Restoran',
    amenity_restaurant_desc: 'Yerli və Avropa mətbəxindən ləziz yeməklər təklif edən restoranımız xidmətinizdədir.',
    
    // Gallery
    gallery_overline: 'Qalereya',
    gallery_title: 'Anlarımız',
    
    // Contact
    contact_overline: 'Əlaqə',
    contact_title: 'Bizimlə Əlaqə',
    contact_address: 'Ünvan',
    contact_phone: 'Telefon',
    contact_email: 'Email',
    contact_social: 'Sosial Media',
    
    // Footer
    footer_rights: 'Bütün hüquqlar qorunur',
    footer_description: 'Quba Qəçrəş yolunda, dağların qoynunda, çay kənarında premium istirahət mərkəzi',
    
    // Admin
    admin_login: 'Admin Giriş',
    admin_email: 'Email',
    admin_password: 'Parol',
    admin_login_btn: 'Daxil Ol',
    admin_logout: 'Çıxış',
    admin_dashboard: 'İdarə Paneli',
    admin_reservations: 'Rezervasyonlar',
    admin_cottages: 'Kotteclər',
    admin_customers: 'Müştərilər',
    admin_settings: 'Parametrlər',
    
    // Reservation
    reservation_calendar: 'Rezervasiya Təqvimi',
    reservation_new: 'Yeni Rezervasiya',
    reservation_customer: 'Müştəri Adı',
    reservation_phone: 'Telefon',
    reservation_checkin: 'Giriş Tarixi',
    reservation_checkout: 'Çıxış Tarixi',
    reservation_total: 'Ümumi Məbləğ',
    reservation_deposit: 'Beh (Kaparo)',
    reservation_status: 'Ödəniş Statusu',
    reservation_method: 'Ödəniş Üsulu',
    reservation_notes: 'Qeyd',
    reservation_save: 'Yadda Saxla',
    reservation_cancel: 'Ləğv Et',
    reservation_empty: 'Boş',
    reservation_paid: 'Ödəndi',
    reservation_unpaid: 'Ödənmədi',
    reservation_deposit_paid: 'Beh Alındı',
    
    // Cottage Management
    cottage_add: 'Yeni Kottec',
    cottage_name: 'Kottec Adı',
    cottage_description: 'Açıqlama',
    cottage_capacity: 'Tutum',
    cottage_image: 'Şəkil URL',
    cottage_order: 'Sıra Nömrəsi',
    cottage_active: 'Aktiv',
    cottage_delete: 'Sil',
    cottage_edit: 'Redaktə Et',
    
    // Customer
    customer_list: 'Müştəri Siyahısı',
    customer_export: 'Excel-ə Aktar',
    customer_name: 'Müştəri',
    customer_phone: 'Telefon',
    customer_reservations: 'Rezervasiya',
    customer_total: 'Ümumi Xərc',
    customer_deposit: 'Beh',
    customer_remaining: 'Qalıq',
    customer_last: 'Son Rezervasiya',
    customer_details: 'Detallar',
    
    // Stats
    stats_total_deposit: 'Ümumi Beh',
    stats_total_reservations: 'Ümumi Rezervasiya',
    stats_remaining: 'Qalıq',
    
    // Common
    save: 'Yadda Saxla',
    cancel: 'Ləğv Et',
    delete: 'Sil',
    edit: 'Redaktə',
    add: 'Əlavə Et',
    close: 'Bağla',
    search: 'Axtar',
    loading: 'Yüklənir...',
    error: 'Xəta baş verdi',
    success: 'Uğurlu',
    today: 'Bu gün',
    days_14: '14 Gün',
    months_3: '3 Aylıq',
  },
  en: {
    // Navigation
    nav_home: 'Home',
    nav_about: 'About',
    nav_cottages: 'Cottages',
    nav_amenities: 'Amenities',
    nav_gallery: 'Gallery',
    nav_contact: 'Contact',
    nav_admin: 'Admin',
    
    // Hero
    hero_title: 'Peace in the Mountains',
    hero_subtitle: 'An unforgettable retreat experience in nature, by the river, on the Quba Qachresh road',
    hero_cta: 'Explore',
    
    // About
    about_overline: 'About Us',
    about_title: 'In the Heart of Nature',
    about_text: 'Oriva Quba is located in one of the most beautiful corners of Azerbaijan - on the Qachresh road of Quba region. Our location offers both mountain views and direct access to the riverside. Our modern cottages are waiting for you to spend quality time with your family or friends.',
    
    // Cottages
    cottages_overline: 'Cottages',
    cottages_title: 'Premium Retreat',
    cottages_capacity: 'Guests',
    cottages_view_details: 'Details',
    
    // Amenities
    amenities_overline: 'Amenities',
    amenities_title: 'For You',
    amenity_river: 'Direct River Access',
    amenity_river_desc: 'Our cottages are located right by the river. You can relax listening to the river sounds in the evenings.',
    amenity_mountain: 'Mountain View',
    amenity_mountain_desc: 'You can enjoy the magnificent view of Quba mountains from every cottage.',
    amenity_playground: 'Kids Playground',
    amenity_playground_desc: 'A safe and fun play area is available for children.',
    amenity_restaurant: 'Restaurant',
    amenity_restaurant_desc: 'Our restaurant offering delicious dishes from local and European cuisine is at your service.',
    
    // Gallery
    gallery_overline: 'Gallery',
    gallery_title: 'Our Moments',
    
    // Contact
    contact_overline: 'Contact',
    contact_title: 'Get in Touch',
    contact_address: 'Address',
    contact_phone: 'Phone',
    contact_email: 'Email',
    contact_social: 'Social Media',
    
    // Footer
    footer_rights: 'All rights reserved',
    footer_description: 'Premium resort on Quba Qachresh road, in the mountains, by the river',
    
    // Admin
    admin_login: 'Admin Login',
    admin_email: 'Email',
    admin_password: 'Password',
    admin_login_btn: 'Login',
    admin_logout: 'Logout',
    admin_dashboard: 'Dashboard',
    admin_reservations: 'Reservations',
    admin_cottages: 'Cottages',
    admin_customers: 'Customers',
    admin_settings: 'Settings',
    
    // Reservation
    reservation_calendar: 'Reservation Calendar',
    reservation_new: 'New Reservation',
    reservation_customer: 'Customer Name',
    reservation_phone: 'Phone',
    reservation_checkin: 'Check-in Date',
    reservation_checkout: 'Check-out Date',
    reservation_total: 'Total Amount',
    reservation_deposit: 'Deposit',
    reservation_status: 'Payment Status',
    reservation_method: 'Payment Method',
    reservation_notes: 'Notes',
    reservation_save: 'Save',
    reservation_cancel: 'Cancel',
    reservation_empty: 'Empty',
    reservation_paid: 'Paid',
    reservation_unpaid: 'Unpaid',
    reservation_deposit_paid: 'Deposit Paid',
    
    // Cottage Management
    cottage_add: 'Add Cottage',
    cottage_name: 'Cottage Name',
    cottage_description: 'Description',
    cottage_capacity: 'Capacity',
    cottage_image: 'Image URL',
    cottage_order: 'Order Number',
    cottage_active: 'Active',
    cottage_delete: 'Delete',
    cottage_edit: 'Edit',
    
    // Customer
    customer_list: 'Customer List',
    customer_export: 'Export to Excel',
    customer_name: 'Customer',
    customer_phone: 'Phone',
    customer_reservations: 'Reservations',
    customer_total: 'Total Spent',
    customer_deposit: 'Deposit',
    customer_remaining: 'Remaining',
    customer_last: 'Last Reservation',
    customer_details: 'Details',
    
    // Stats
    stats_total_deposit: 'Total Deposit',
    stats_total_reservations: 'Total Reservations',
    stats_remaining: 'Remaining',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error occurred',
    success: 'Success',
    today: 'Today',
    days_14: '14 Days',
    months_3: '3 Months',
  },
  ru: {
    // Navigation
    nav_home: 'Главная',
    nav_about: 'О нас',
    nav_cottages: 'Коттеджи',
    nav_amenities: 'Удобства',
    nav_gallery: 'Галерея',
    nav_contact: 'Контакты',
    nav_admin: 'Админ',
    
    // Hero
    hero_title: 'Покой в Горах',
    hero_subtitle: 'Незабываемый отдых на природе, у реки, на дороге Губа Гачреш',
    hero_cta: 'Исследовать',
    
    // About
    about_overline: 'О нас',
    about_title: 'В Сердце Природы',
    about_text: 'Орива Губа расположена в одном из самых красивых уголков Азербайджана - на дороге Гачреш Губинского района. Наше место предлагает как горные виды, так и прямой выход к реке. Наши современные коттеджи ждут вас, чтобы провести качественное время с семьей или друзьями.',
    
    // Cottages
    cottages_overline: 'Коттеджи',
    cottages_title: 'Премиум Отдых',
    cottages_capacity: 'Гостей',
    cottages_view_details: 'Подробнее',
    
    // Amenities
    amenities_overline: 'Удобства',
    amenities_title: 'Для Вас',
    amenity_river: 'Прямой Выход к Реке',
    amenity_river_desc: 'Наши коттеджи расположены прямо у реки. Вечером можно расслабиться под звуки реки.',
    amenity_mountain: 'Вид на Горы',
    amenity_mountain_desc: 'Из каждого коттеджа открывается великолепный вид на горы Губы.',
    amenity_playground: 'Детская Площадка',
    amenity_playground_desc: 'Для детей доступна безопасная и веселая игровая площадка.',
    amenity_restaurant: 'Ресторан',
    amenity_restaurant_desc: 'Наш ресторан предлагает вкусные блюда местной и европейской кухни.',
    
    // Gallery
    gallery_overline: 'Галерея',
    gallery_title: 'Наши Моменты',
    
    // Contact
    contact_overline: 'Контакты',
    contact_title: 'Свяжитесь с Нами',
    contact_address: 'Адрес',
    contact_phone: 'Телефон',
    contact_email: 'Эл. почта',
    contact_social: 'Соцсети',
    
    // Footer
    footer_rights: 'Все права защищены',
    footer_description: 'Премиум курорт на дороге Губа Гачреш, в горах, у реки',
    
    // Admin
    admin_login: 'Вход Админа',
    admin_email: 'Эл. почта',
    admin_password: 'Пароль',
    admin_login_btn: 'Войти',
    admin_logout: 'Выход',
    admin_dashboard: 'Панель управления',
    admin_reservations: 'Бронирования',
    admin_cottages: 'Коттеджи',
    admin_customers: 'Клиенты',
    admin_settings: 'Настройки',
    
    // Reservation
    reservation_calendar: 'Календарь Бронирования',
    reservation_new: 'Новое Бронирование',
    reservation_customer: 'Имя Клиента',
    reservation_phone: 'Телефон',
    reservation_checkin: 'Дата Заезда',
    reservation_checkout: 'Дата Выезда',
    reservation_total: 'Общая Сумма',
    reservation_deposit: 'Задаток',
    reservation_status: 'Статус Оплаты',
    reservation_method: 'Способ Оплаты',
    reservation_notes: 'Примечания',
    reservation_save: 'Сохранить',
    reservation_cancel: 'Отмена',
    reservation_empty: 'Свободно',
    reservation_paid: 'Оплачено',
    reservation_unpaid: 'Не оплачено',
    reservation_deposit_paid: 'Задаток Получен',
    
    // Cottage Management
    cottage_add: 'Добавить Коттедж',
    cottage_name: 'Название Коттеджа',
    cottage_description: 'Описание',
    cottage_capacity: 'Вместимость',
    cottage_image: 'URL Изображения',
    cottage_order: 'Порядковый Номер',
    cottage_active: 'Активен',
    cottage_delete: 'Удалить',
    cottage_edit: 'Редактировать',
    
    // Customer
    customer_list: 'Список Клиентов',
    customer_export: 'Экспорт в Excel',
    customer_name: 'Клиент',
    customer_phone: 'Телефон',
    customer_reservations: 'Бронирования',
    customer_total: 'Всего Потрачено',
    customer_deposit: 'Задаток',
    customer_remaining: 'Остаток',
    customer_last: 'Последнее Бронирование',
    customer_details: 'Детали',
    
    // Stats
    stats_total_deposit: 'Всего Задаток',
    stats_total_reservations: 'Всего Бронирований',
    stats_remaining: 'Остаток',
    
    // Common
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    close: 'Закрыть',
    search: 'Поиск',
    loading: 'Загрузка...',
    error: 'Произошла ошибка',
    success: 'Успешно',
    today: 'Сегодня',
    days_14: '14 Дней',
    months_3: '3 Месяца',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('oriva_language');
    return saved || 'az';
  });

  useEffect(() => {
    localStorage.setItem('oriva_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['az'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
